import Sockets from './sockets';

export const emitEvent = (namespace, event, payload) => {
  Sockets.emitEvent(namespace, event, payload);
};
